import React from "react";

interface StepProps {
    formData: any;
    handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const Step: React.FC<StepProps> = ({ formData, handleChange }) => {
    return (
        <div className="bg-white shadow-sm rounded-lg p-6">
            <div className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900">Personal Information</h2>
                <p className="mt-1 text-sm text-gray-600">Please provide your basic information to get started.</p>
            </div>

            <div className="space-y-8">
                <div className="space-y-6 divide-y divide-gray-200">
                    {/* Contact Information Section */}
                    <div className="space-y-6 pt-6 first:pt-0">
                        <div className="relative">
                            <label className="block text-sm font-medium text-gray-700 mb-2">Name</label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                placeholder="Enter your full name"
                                className="block w-full px-4 py-3 rounded-md border-gray-300 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent hover:border-gray-400 transition-colors"
                            />
                        </div>

                        <div className="relative">
                            <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                placeholder="you@example.com"
                                className="block w-full px-4 py-3 rounded-md border-gray-300 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent hover:border-gray-400 transition-colors"
                            />
                            <p className="mt-1 text-sm text-gray-500">We'll never share your email with anyone else.</p>
                        </div>

                        <div className="relative">
                            <label className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
                            <input
                                type="tel"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                placeholder="(555) 555-5555"
                                className="block w-full px-4 py-3 rounded-md border-gray-300 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent hover:border-gray-400 transition-colors"
                            />
                        </div>
                    </div>

                    {/* Social Links Section */}
                    <div className="space-y-6 pt-6">
                        <h3 className="text-lg font-medium text-gray-900">Social Links</h3>
                        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                            <div className="relative">
                                <label className="block text-sm font-medium text-gray-700 mb-2">LinkedIn</label>
                                <input
                                    type="url"
                                    name="linkedin"
                                    value={formData.linkedin}
                                    onChange={handleChange}
                                    placeholder="https://linkedin.com/in/username"
                                    className="block w-full px-4 py-3 rounded-md border-gray-300 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent hover:border-gray-400 transition-colors"
                                />
                            </div>

                            <div className="relative">
                                <label className="block text-sm font-medium text-gray-700 mb-2">GitHub</label>
                                <input
                                    type="url"
                                    name="github"
                                    value={formData.github}
                                    onChange={handleChange}
                                    placeholder="https://github.com/username"
                                    className="block w-full px-4 py-3 rounded-md border-gray-300 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent hover:border-gray-400 transition-colors"
                                />
                            </div>

                            <div className="relative md:col-span-2">
                                <label className="block text-sm font-medium text-gray-700 mb-2">Personal Website</label>
                                <input
                                    type="url"
                                    name="website"
                                    value={formData.website}
                                    onChange={handleChange}
                                    placeholder="https://yourwebsite.com"
                                    className="block w-full px-4 py-3 rounded-md border-gray-300 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent hover:border-gray-400 transition-colors"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Summary Section */}
                    <div className="space-y-6 pt-6">
                        <div className="relative">
                            <label className="block text-sm font-medium text-gray-700 mb-2">Professional Summary</label>
                            <p className="mt-1 mb-2 text-sm text-gray-500">Write a brief summary about your professional background and goals.</p>
                            <textarea
                                name="summary"
                                value={formData.summary}
                                onChange={handleChange}
                                rows={4}
                                placeholder="Tell us about yourself..."
                                className="block w-full px-4 py-3 rounded-md border-gray-300 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent hover:border-gray-400 transition-colors resize-none"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Step;